import React, { useState, lazy } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import orderBy from 'lodash/orderBy';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import env from 'Env';
import LazyModal from 'Components/Utility/LazyModal';

const UserTagsModal = lazy(() => import(/* webpackChunkName: "UserTagsModal" */ 'Components/Product/UserTags/UserTagsModal'));

const USER_SCORE_THRESHOLD = env.userTags.userScoreThreshold;
const PRODUCT_COUNT_THRESHOLD = env.algolia.indexName === 'fan' ? 5 : 0;

const isEnglish = window.locale === 'en';

const ProductUserTags = ({
  isLoggedIn,
  isAdmin,
  product,
  product: {
    userTags: tags = [],
    type,
    name,
    slug,
  },
}) => {
  const [open, setOpen] = useState(false); // Used to open the modal

  if (!['game', 'dlc'].includes(type)) {
    return false;
  }

  if (!isLoggedIn) {
    return false;
  }

  const visibleTags = orderBy(tags.filter(tag => tag.productCount >= PRODUCT_COUNT_THRESHOLD && tag.userScore >= USER_SCORE_THRESHOLD), ['userScore', 'productCount', 'score'], ['desc', 'asc', 'desc']);

  if (!visibleTags.length && (!isLoggedIn || !isEnglish)) {
    return false;
  }

  if (!isLoggedIn && !isEnglish) {
    return false;
  }

  return (
    <React.Fragment>
      <button className="btn btn-sm btn-outline-grey mb-3" onClick={() => setOpen(true)}>
        <FormattedMessage id="product-user-tags.add-tags" defaultMessage="Add Tags" />
        <FontAwesomeIcon icon={faPlus} className="ml-2" />
      </button>

      <LazyModal
        hasCloseFooter
        open={open}
        setOpen={setOpen}
        className="user-tags-modal"
        size="lg"
      >
        <UserTagsModal
          tags={tags}
          name={name}
          slug={product.type === 'game' && product.parent_slug ? product.parent_slug : slug}
          type={type}
          isAdmin={isAdmin}
        />
      </LazyModal>
    </React.Fragment>
  );
};

ProductUserTags.propTypes = {
  isLoggedIn: PropTypes.bool,
  isAdmin: PropTypes.bool,
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    userTags: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

ProductUserTags.defaultProps = {
  isLoggedIn: false,
  isAdmin: false,
};

const mapStateToProps = ({
  auth,
}) => ({
  isLoggedIn: !!auth.authenticated,
  isAdmin: auth.role === 'admin',
});

export default connect(mapStateToProps)(ProductUserTags);
